import { FC } from 'react';
import { getBookingStyles } from './BookingStyles';

interface BookingErrorProps {
    error: string;
}

const BookingError: FC<BookingErrorProps> = ({ error }) => {
    return (
        <div className="status-screen">
            <style>{getBookingStyles()}</style>
            <div className="portal-message-card">
                <div className="status-tag error">Invalid Link</div>
                <h1>Link no longer valid</h1>
                <p>{error}</p>
                <button onClick={() => window.close()} className="solid-btn">Exit Portal</button>
            </div>
        </div>
    );
};

export default BookingError;
